const prefixCls = 'web.procure.';

/**
 * 采购模块国际化资源
 */
export const localesProcure = {
  // 表格列名
  [prefixCls + 'table.column.psku']: {
    zh_CN: 'PSKU',
    en_GB: 'PSKU',
  },
  [prefixCls + 'table.column.title']: {
    zh_CN: '品名',
    en_GB: 'Product Name',
  },
  [prefixCls + 'table.column.standard']: {
    zh_CN: '标签',
    en_GB: 'Standard',
  },
  [prefixCls + 'table.column.expressCompany']: {
    zh_CN: '快递公司',
    en_GB: 'Express Company',
  },
  [prefixCls + 'table.column.expressNumber']: {
    zh_CN: '快递单号',
    en_GB: 'Express Number',
  },
  [prefixCls + 'table.column.isBackupOrder']: {
    zh_CN: '是否急单',
    en_GB: 'Backup Order',
  },
  [prefixCls + 'table.column.airFreightNumber']: {
    zh_CN: '货运单号',
    en_GB: 'Air Freight No.',
  },
  [prefixCls + 'table.column.quantity']: {
    zh_CN: '数量',
    en_GB: 'Quantity',
  },
  [prefixCls + 'table.column.unitPrice']: {
    zh_CN: '拿货价',
    en_GB: 'Unit Price',
  },
  [prefixCls + 'table.column.totalAmount']: {
    zh_CN: '总计(元)',
    en_GB: 'Total (¥)',
  },
  [prefixCls + 'table.column.purchaseDate']: {
    zh_CN: '采购日期',
    en_GB: 'Purchase Date',
  },
  [prefixCls + 'table.column.type']: {
    zh_CN: '类型',
    en_GB: 'Type',
  },
  [prefixCls + 'table.column.remarks']: {
    zh_CN: '备注',
    en_GB: 'Remarks',
  },
  [prefixCls + 'table.column.actions']: {
    zh_CN: '操作',
    en_GB: 'Actions',
  },

  // 搜索和筛选
  [prefixCls + 'filter.searchPlaceholder']: {
    zh_CN: '搜索PSKU',
    en_GB: 'Search PSKU',
  },
  [prefixCls + 'filter.type']: {
    zh_CN: '全部类型',
    en_GB: 'Type',
  },
  [prefixCls + 'filter.isUrgent']: {
    zh_CN: '是否急单',
    en_GB: 'Urgent Order',
  },
  [prefixCls + 'filter.yes']: {
    zh_CN: '是',
    en_GB: 'Yes',
  },
  [prefixCls + 'filter.no']: {
    zh_CN: '否',
    en_GB: 'No',
  },
  [prefixCls + 'filter.allTypes']: {
    zh_CN: '全部类型',
    en_GB: 'All Types',
  },
  [prefixCls + 'filter.startDate']: {
    zh_CN: '开始日期',
    en_GB: 'Start Date',
  },
  [prefixCls + 'filter.endDate']: {
    zh_CN: '结束日期',
    en_GB: 'End Date',
  },
  [prefixCls + 'filter.air']: {
    zh_CN: '是否空运',
    en_GB: 'Air Freight',
  },
  [prefixCls + 'filter.airAll']: {
    zh_CN: '全部',
    en_GB: 'All',
  },
  [prefixCls + 'filter.airExpress']: {
    zh_CN: '空运',
    en_GB: 'Air Express',
  },
  [prefixCls + 'filter.airNormal']: {
    zh_CN: '普通快递',
    en_GB: 'Normal Express',
  },
  [prefixCls + 'filter.airNo']: {
    zh_CN: '货运单号',
    en_GB: 'Air Freight Number',
  },
  [prefixCls + 'filter.express']: {
    zh_CN: '快递公司',
    en_GB: 'Express Company',
  },
  [prefixCls + 'filter.expressNo']: {
    zh_CN: '快递单号',
    en_GB: 'Express Number',
  },
  [prefixCls + 'filter.dateRange']: {
    zh_CN: '日期范围',
    en_GB: 'Date Range',
  },
  [prefixCls + 'filter.advancedSearch']: {
    zh_CN: '高级搜索',
    en_GB: 'Advanced Search',
  },
  [prefixCls + 'filter.reset']: {
    zh_CN: '重置',
    en_GB: 'Reset',
  },
  [prefixCls + 'filter.search']: {
    zh_CN: '搜索',
    en_GB: 'Search',
  },

  // 按钮和操作
  [prefixCls + 'action.createProcurement']: {
    zh_CN: '新建采购',
    en_GB: 'New Purchase',
  },
  [prefixCls + 'action.update']: {
    zh_CN: '数据更新',
    en_GB: 'Update Data',
  },
  [prefixCls + 'action.export']: {
    zh_CN: '导出数据',
    en_GB: 'Export Data',
  },
  [prefixCls + 'action.import']: {
    zh_CN: '导入数据',
    en_GB: 'Import Data',
  },

  // 状态
  [prefixCls + 'status.pending']: {
    zh_CN: '待处理',
    en_GB: 'Pending',
  },
  [prefixCls + 'status.processing']: {
    zh_CN: '处理中',
    en_GB: 'Processing',
  },
  [prefixCls + 'status.completed']: {
    zh_CN: '已完成',
    en_GB: 'Completed',
  },
  [prefixCls + 'status.cancelled']: {
    zh_CN: '已取消',
    en_GB: 'Cancelled',
  },

  // 类型
  [prefixCls + 'type.purchase']: {
    zh_CN: '采购',
    en_GB: 'Purchase',
  },
  [prefixCls + 'type.arrival']: {
    zh_CN: '到货',
    en_GB: 'Arrival',
  },
  [prefixCls + 'type.return']: {
    zh_CN: '退货',
    en_GB: 'Return',
  },

  // 错误信息
  [prefixCls + 'error.fetchFailed']: {
    zh_CN: '获取采购数据失败',
    en_GB: 'Failed to fetch procurement data',
  },
  [prefixCls + 'error.createFailed']: {
    zh_CN: '创建采购记录失败',
    en_GB: 'Failed to create procurement record',
  },
  [prefixCls + 'error.updateFailed']: {
    zh_CN: '更新采购记录失败',
    en_GB: 'Failed to update procurement record',
  },
  [prefixCls + 'error.deleteFailed']: {
    zh_CN: '删除采购记录失败',
    en_GB: 'Failed to delete procurement record',
  },

  // 表单相关
  [prefixCls + 'modal.editTitle']: {
    zh_CN: '编辑',
    en_GB: 'Edit',
  },
  [prefixCls + 'modal.createTitle']: {
    zh_CN: '创建',
    en_GB: 'Create',
  },
  [prefixCls + 'form.psku']: {
    zh_CN: 'psku',
    en_GB: 'PSKU',
  },
  [prefixCls + 'form.title']: {
    zh_CN: '品名',
    en_GB: 'Product Name',
  },
  [prefixCls + 'form.expressCompany']: {
    zh_CN: '快递公司',
    en_GB: 'Express Company',
  },
  [prefixCls + 'form.expressNumber']: {
    zh_CN: '快递单号',
    en_GB: 'Express Number',
  },
  [prefixCls + 'form.air_no']: {
    zh_CN: '货运单号',
    en_GB: 'Air Freight Number',
  },
  [prefixCls + 'form.airFreightNumber']: {
    zh_CN: '空运入仓号',
    en_GB: 'Air Freight Number',
  },
  [prefixCls + 'form.quantity']: {
    zh_CN: '数量',
    en_GB: 'Quantity',
  },
  [prefixCls + 'form.totalAmount']: {
    zh_CN: '总金额',
    en_GB: 'Total Amount',
  },
  [prefixCls + 'form.purchaseDate']: {
    zh_CN: '采购日期',
    en_GB: 'Purchase Date',
  },
  [prefixCls + 'form.type']: {
    zh_CN: '类型',
    en_GB: 'Type',
  },
  [prefixCls + 'form.remarks']: {
    zh_CN: '备注',
    en_GB: 'Remarks',
  },
  [prefixCls + 'form.remarksPlaceholder']: {
    zh_CN: '请输入备注',
    en_GB: 'Enter remarks',
  },
};
